import { LOGIN_SUCCESS, LOGIN_FAILURE, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE } from '../actions/types'

const initialState = {
  status: 0,
  tryLogin: false,
}
const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
      }
    case LOGIN_FAILURE:
      return {
        ...state,
        status: action.payload,
        tryLogin: true,
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        status: 200,
      }
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        status: action.payload,
        tryLogin: true,
      }
    default:
      return state
  }
}

export default login



// WEBPACK FOOTER //
// ./src/reducers/login.js